import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';import RecentlyViewed from './RecentlyViewed';
import { Helmet } from 'react-helmet';
import CarImageCarousel from "./Components/CarImageCarousel";
import CarFeatureList from './Components/CarFeatureList';
import Spinner from './Components/Spinner';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaHeart, FaRegHeart, FaShareAlt } from 'react-icons/fa';
import CompModal from './Components/CompModal';



function CarDetail() {
    const navigate = useNavigate();
  const { id } = useParams();
  const [car, setCar] = useState(null);
  const [showPhone, setShowPhone] = useState(false);
  const [comparables, setComparables] = useState([]); 
  const [showFullDescription, setShowFullDescription] = useState(false);
const [comparablesLoading, setComparablesLoading] = useState(true);
const [showAllPrices, setShowAllPrices] = useState(false);
const { userEmail } = useAuth();
const { user } = useAuth();
const [saved, setSaved] = useState(false);
const [saving, setSaving] = useState(false);
const [showToast, setShowToast] = useState('');
const [mestimate, setMestimate] = useState(null);
const [showCompModal, setShowCompModal] = useState(false);
const [compsUsed, setCompsUsed] = useState([]);


useEffect(() => {
  if (!user?.id || !car) return;
  fetch(`${process.env.REACT_APP_API_BASE}/saved/${user.id}`)
    .then(res => res.json())
    .then(ids => setSaved(ids.includes(car.id)))
    .catch(() => {});
}, [user, car]);

const toggleSave = async () => {
  if (!user?.id) {
    showTempToast('Sign in to save this car');
    return;
  }
  if (saving) return;
  setSaving(true);

  try {
    const method = saved ? 'DELETE' : 'POST';
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/saved`, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: user.id, carId: car.id })
    });
    if (res.ok) setSaved(!saved);
  } catch {}
  finally {
    setSaving(false);
  }
};

const handleShare = async () => {
  const url = `${window.location.origin}/car/${car.id}`;
  if (navigator.share) {
    try {
      await navigator.share({ title: `${car.year} ${car.make} ${car.model}`, url });
    } catch {}
  } else {
    navigator.clipboard.writeText(url).then(() =>
      showTempToast('Link copied to clipboard!')
    ).catch(() =>
      showTempToast('Failed to copy link')
    );
  }
};

const showTempToast = (msg) => {
  setShowToast(msg);
  setTimeout(() => setShowToast(''), 2000);
};

useEffect(() => {
  if (car) {
    window.gtag?.('event', 'view_car_detail', {
      car_id: car.id,
      make: car.make,
      model: car.model,
      year: car.year,
      price: car.price,
    });
  }
}, [car]);

useEffect(() => {
  fetch(`${process.env.REACT_APP_API_BASE}/cars/${id}`)
    .then(res => res.json())
    .then(data => {
      setCar(data);

      // Store in recently viewed (max 5)
      const stored = localStorage.getItem('recentlyViewedCars');
      let viewed = stored ? JSON.parse(stored) : [];

      viewed = viewed.filter(c => c.id !== data.id); // remove duplicates
      viewed.unshift({
        id: data.id,
        make: data.make,
        model: data.model,
        year: data.year,
        price: data.price,
        images: data.images[0]
      });

      if (viewed.length > 5) viewed = viewed.slice(0, 5);
      localStorage.setItem('recentlyViewedCars', JSON.stringify(viewed));
    });
setComparables("");
setComparablesLoading(true);
  fetch(`${process.env.REACT_APP_API_BASE}/cars/${id}/comparables`)
  .then(res => res.json())
  .then(data => {
    setComparables(data.comps || []);
     setMestimate(data.mestimate || null);
      setCompsUsed(data.compsUsed ?? []);
    setComparablesLoading(false);
  })
  .catch(() => setComparablesLoading(false));

}, [id]);

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11 && cleaned[0] === '1') {
      return `+1 (${cleaned.slice(1,4)}) ${cleaned.slice(4,7)}-${cleaned.slice(7)}`;
    }
    return phone;
  };

  if (!car) return  <Spinner /> ;

  const rawFeatures = car.features ?? "";
  const featureIcons = {
    "Sunroof": "☀️", "Navigation": "🛰️", "Heated Seats": "🔥", "Remote Start": "🚗",
    "Bluetooth": "📱", "Backup Camera": "🎥", "Leather Seats": "💺", "Apple CarPlay": "🍎", "Android Auto": "🤖"
  };

  return (
    <>
 {car && (
  <Helmet>
      <title>{`${car.year} ${car.make} ${car.model}`}</title>
  <meta name="description" content={`Explore detailed specs, price history, and market insights for this ${car.year} ${car.make} ${car.model}.`} />
  <link rel="canonical" href={`https://www.meshum.com/car/${car.id}`} />
  <meta property="og:type" content="product" />
<meta property="og:image" content={car.images?.[0] || "https://meshumimages.blob.core.windows.net/websiteimages/defaultCar.jpg"} />
<meta name="twitter:card" content="summary_large_image" />

    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": `${car.year} ${car.make} ${car.model} ${car.trim ?? ""}`.trim(),
        "description": `${car.mileage.toLocaleString()} miles, ${car.transmission}, ${car.fuel}`,
        "brand": {
          "@type": "Brand",
          "name": car.make
        },
        "sku": car.vin,
        "mpn": car.vin,
        "image": car.images?.[0] || "https://meshumimages.blob.core.windows.net/websiteimages/defaultCar.jpg",
        "offers": {
          "@type": "Offer",
          "url": `https://www.meshum.com/car/${car.id}`,
          "priceCurrency": "USD",
          "price": car.price,
          "itemCondition": "https://schema.org/UsedCondition",
          "availability": car.soldDate ? "https://schema.org/SoldOut" : "https://schema.org/InStock",
          "seller": {
            "@type": "Organization",
            "name": car.dealerName ?? "Private Seller"
          }
        }
      })}
    </script>
  </Helmet>
)}

    <div style={{ maxWidth: "1200px", margin: "2rem auto", padding: "1rem" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
   <CarImageCarousel imageUrls={car.images} />


        <div>
       <div className="mb-4">
<div style={{
  fontSize: '1.25rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexGrow: 1,
  minWidth: 0,  // required for ellipsis in flex layout
  display: 'flex',
  alignItems: 'center'
}}>
  {car.year} {car.make.toUpperCase()} {car.model} {car.trim}
</div>

{car.soldDate && car.insertDate && (
  <div style={{
    backgroundColor: "#f44336",
    color: "#fff",
    padding: "0.5rem",
    borderRadius: "6px",
    marginBottom: "1rem"
  }}>
    SOLD on {new Date(car.soldDate).toLocaleDateString()}<br />
    Time on Market: {
      Math.ceil(
        (new Date(car.soldDate) - new Date(car.insertDate)) / (1000 * 60 * 60 * 24)
      )
    } days
  </div>
)}

  <div className="text-2xl font-semibold text-green-600 mt-2">
    ${car.price.toLocaleString()}
  </div>

  <div className="text-sm text-gray-600 mt-1">
    {car.mileage.toLocaleString()} miles • {car.dealerCity}, {car.dealerState}
  </div>

  {car.dealerName && (
    <div className="text-sm text-gray-600">
     <span className="font-medium text-gray-700">Dealer:</span>{' '}
<a
  href={`/dealer/${car.dealerId}`}
  className="text-blue-600 underline hover:text-blue-800"
>
  {car.dealerName}
</a>
    </div>
  )}
</div>

          {car.condition && <p><strong>Condition:</strong> {car.condition}</p>}
          {car.vin && (
            <a href={`https://www.carfax.com/VehicleHistory/p/Report.cfx?vin=${car.vin}`} target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex", alignItems: "center", gap: "0.5rem", marginTop: "1rem",
              padding: "8px 12px", backgroundColor: "#0077cc", color: "#fff", borderRadius: "6px", textDecoration: "none"
            }}>
              <img src="https://meshumimages.blob.core.windows.net/websiteimages/CARFAX_Logo.svg.png" alt="Carfax" style={{ height: "24px" }} />
              View Free CARFAX Report
            </a>
          )}
{car.dealerPhone && (
  <div style={{ marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem" }}>
    <div>
      {!showPhone ? (
        <button
          onClick={() => {
            fetch(`${process.env.REACT_APP_API_BASE}/cars/${car.id}/reveal-phone`, { method: 'POST' }).catch(err => console.error("Phone reveal log failed:", err));
            setShowPhone(true);
          }}
          style={{
            padding: "8px 14px",
            fontSize: "0.9rem",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#0077cc",
            color: "#fff",
            cursor: "pointer"
          }}
        >
          📞 Show Dealer Phone Number
        </button>
      ) : (
        <p style={{ fontWeight: "bold", fontSize: "1.1rem", margin: 0 }}>
          📞 <a
            href={`tel:${car.dealerPhone}`}
            style={{ color: "#000", textDecoration: "none" }}
          >
            {formatPhoneNumber(car.dealerPhone)}
          </a>
        </p>
      )}
    </div>

    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
      <button
        onClick={handleShare}
        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.4rem', color: '#444' }}
      >
        <FaShareAlt />
      </button>

      <div
        onClick={toggleSave}
        style={{ fontSize: '1.6rem', color: saved ? 'red' : '#888', cursor: 'pointer' }}
      >
        {saved ? <FaHeart /> : <FaRegHeart />}
      </div>
    </div>
  </div>
)}

{comparablesLoading ? (
  <div className="text-sm text-gray-600 mt-2 flex items-center gap-2">
    Meshum Estimate (Mestimate): <Spinner size="small" />
  </div>
) : (
  mestimate && (
    <div className="text-sm text-gray-600 mt-2">
      Meshum Estimate (Mestimate): <strong>${mestimate?.toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong>
    </div>
  )
)}

{mestimate  && (
  <div className="text-sm mt-1 text-blue-600 underline cursor-pointer" onClick={() => setShowCompModal(true)}>
    See comparable sales used
  </div>
)}


        </div>
      </div>

      <div style={{ marginTop: "2rem", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "1rem" }}>
        <div><strong>Trim:</strong> {car.trim}</div>
        <div><strong>Transmission:</strong> {car.transmission}</div>
        <div><strong>Fuel:</strong> {car.fuel}</div>
        <div><strong>MPG:</strong> {car.mpgCity} / {car.mpgHighway}</div>
        <div><strong>Owners:</strong> {car.noOfOwners}</div>
        <div><strong>Title:</strong> {car.titleStatus}</div>
        <div><strong>Engine:</strong> {car.engine}</div>
        <div><strong>Drive:</strong> {car.driveType}</div>
        <div><strong>Dealer:</strong> {car.dealerName}</div>
      </div>


{car?.priceHistory?.length > 0 && (
  <div style={{ marginTop: '1.5rem' }}>
    <h3 style={{ marginBottom: '0.5rem' }}>Price History</h3>

    <table style={{ width: '100%', maxWidth: '500px', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
      <thead>
        <tr style={{ backgroundColor: '#f9f9f9' }}>
          <th style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Date</th>
          <th style={{ textAlign: 'right', padding: '0.5rem', borderBottom: '1px solid #ccc' }}>Price</th>
        </tr>
      </thead>
      <tbody>
        {(showAllPrices ? car.priceHistory : car.priceHistory.slice(0, 1)).map((entry, index) => (
          <tr key={index}>
            <td style={{ textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #eee' }}>
              {new Date(entry.dateChanged).toLocaleDateString()}
            </td>
            <td style={{ textAlign: 'right', padding: '0.5rem', borderBottom: '1px solid #eee' }}>
              ${Number(entry.price).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {car.priceHistory.length > 1 && (
      <div style={{ marginTop: '0.5rem', textAlign: 'left' }}>
        <button
          onClick={() => setShowAllPrices(prev => !prev)}
          style={{
            background: 'none',
            border: 'none',
            color:  '#1a0dab',
            cursor: 'pointer',
            textDecoration: 'underline',
            padding: 0,
            fontSize: '0.9rem'
          }}
        >
          {showAllPrices ? 'View less' : 'View more'}
        </button>
      </div>
    )}
  </div>
)}


{rawFeatures.length > 0 && (
     <CarFeatureList features={rawFeatures.split(',').map(f => f.trim())} />
)}
{car.sellerDesc && (
  <div style={{ marginTop: "2rem", padding: "1rem", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
    <h3 style={{ marginBottom: "0.5rem" }}>Vehicle Description</h3>
    <p
      style={{
        lineHeight: "1.6",
        color: "#444",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: showFullDescription ? "block" : "-webkit-box",
        WebkitLineClamp: showFullDescription ? "none" : 1,
        WebkitBoxOrient: "vertical"
      }}
    >
      {car.sellerDesc}
    </p>
    <button
      onClick={() => setShowFullDescription(!showFullDescription)}
      style={{
        background: "none",
        border: "none",
        color: "#0077cc",
        textDecoration: "underline",
        cursor: "pointer",
        padding: 0,
        marginTop: "0.5rem"
      }}
    >
      {showFullDescription ? "Show less" : "Read more"}
    </button>
  </div>
)}

         
 {comparablesLoading ? (
  <div>
  <p>Loading comparable sales...</p>
  <Spinner/>
  </div>
) : (
  <>
    {comparables.length === 0 ? (
      <strong>No Recently Sold Cars</strong>
    ) : (
      <strong>Recently Sold</strong>
    )}
  </>
)}
{!car.soldDate && comparables.length > 0 && (
  <div className="mt-6">
    <div className="flex overflow-x-auto gap-4 pb-2">
      {comparables.map(comp => {
        const cardContent = (
          <>
            {comp.exactMatch && (
              <span className="absolute bottom-2 right-2 bg-green-600 text-white px-3 py-1 text-sm font-bold rounded-md shadow-md z-10 tracking-wide rotate-[-6deg]">
                ✔ Exact Match
              </span>
            )}
            <img
              src={comp.imageUrl}
              alt={`${comp.year} ${comp.make} ${comp.model}`}
              className="w-full h-40 object-cover rounded-md mb-2"
            />
            <div className="font-semibold text-sm">
              {comp.year} {comp.make} {comp.model} {comp.trim}
            </div>
            <div className="text-gray-600 text-sm">{comp.mileage.toLocaleString()} miles</div>

            <div className="text-lg font-semibold mt-2">  
              <span className="absolute top-2 left-2 bg-red-600 text-white px-2 py-1 text-xs rounded-md shadow-md z-10">
                Sold
              </span>
              {!userEmail ? (
                <span>${comp.price.toLocaleString()}</span>
              ) : (
                <div className="relative text-gray-500">
                  <div className="blur-sm select-none">••••••</div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // prevent outer card click
                        navigate('/login');
                      }}
                      className="bg-blue-600 text-white px-3 py-1 text-xs rounded hover:bg-blue-700"
                    >
                      Sign in to view price
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="text-xs text-gray-500">{comp.dealerCity}, {comp.dealerState}</div> */}
            <div className="text-xs text-gray-500">{comp.dealerName}</div>
          </>
        );

        return (
          <div
            key={comp.id}
            className="relative border rounded-xl shadow bg-white p-3 min-w-[250px] max-w-[250px] flex-shrink-0 cursor-pointer hover:shadow-md"
            onClick={() => {
              if (userEmail) {
                navigate(`/car/${comp.id}`);
              }
            }}
          >
            {cardContent}
          </div>
        );
      })}
    </div>
  </div>
)}

          {/* )}
        </div>
      )} */}
      
      <RecentlyViewed cars={JSON.parse(localStorage.getItem('recentlyViewedCars') || '[]')} />
      
   {showCompModal && (
  <CompModal comps={compsUsed} onClose={() => setShowCompModal(false)} />
)}



    </div>
</>  );
}

export default CarDetail;
